module.exports = __webpack_public_path__ + "img/Logo_DMB-RS.5f483f63.svg";